import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
  standalone: false,
})
export class sortPipe implements PipeTransform {
  transform(array: Record<string, number>[], field: string): Record<string, number>[] {
    array.sort((a: Record<string, number>, b: Record<string, number>) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
